import { debounce } from 'lodash';

import { search } from '@/api/RegionApi';

import { buildSelectableRegion } from '@/utils/buildSelectable';

import { Selectable } from '@/components/selectBox/selectBox';

export function useRegionsSearch(searchFilters?: Record<string, unknown>) {
  const searchQuery = ref('');
  const isLoading = ref(false);
  const regionOptions = ref<Selectable<number>[]>([]);

  const searchRegions = debounce(async (query: string) => {
    const response = await search({
      filters: {
        ...searchFilters,
        search: query
      }
    });
    regionOptions.value = response.map((region) =>
      buildSelectableRegion(region)
    ) as Selectable<number>[];

    isLoading.value = false;
  }, 300);

  function onQueryChange(query: string): void {
    isLoading.value = true;
    searchQuery.value = query;

    searchRegions(query);
  }

  return {
    regionOptions,
    isLoading,
    onQueryChange
  };
}
